import React from 'react';
import PropTypes from 'prop-types';
import {DashboardCard as PepsicoDashboardCard} from '@pepsico-ds/ui';

/**
 * DashboardCard renders with specified properties.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.centralIcon - The central icon for the card.
 * @param {Object} props.ctaPrimary - The primary call-to-action for the card.
 * @param {string} props.title - The title of the card.
 * @param {boolean} props.isDark - Whether the card is in dark mode.
 * @returns {JSX.Element} The rendered DashboardCard component.
 */
const DashboardCard = ({centralIcon, ctaPrimary, title, isDark}) => {
  return (
    <PepsicoDashboardCard
      isDark={isDark}
      centralIcon={centralIcon}
      ctaPrimary={ctaPrimary}
      title={title}
      className='[&>.icon-wrapper]:!h-10 [&>.icon-wrapper]:!w-10 [&>.icon-wrapper]:!bg-[#0A0A0A] [&>.icon-wrapper]:!p-0 [&>.icon-wrapper_.icon]:!text-[#0069D7]'
    />
  );
};

DashboardCard.propTypes = {
  centralIcon: PropTypes.string.isRequired,
  ctaPrimary: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isDark: PropTypes.bool
};

export default React.memo(DashboardCard);
